import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const promotionsService = {
    // Public, paginated list of live promotions ("Акції") for the home page.
    getAll: async (params) => {
        try {
            const res = await axiosService.get(endPoints.promotions.base, {
                params,
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    // Validate a promo code at checkout. Resolves with the matching live
    // promotion (incl. discount_percent) or rejects (404) when none matches.
    apply: async (code) => {
        try {
            const res = await axiosService.post(endPoints.promotions.apply, {code});

            return res;
        } catch (error) {
            throw error;
        }
    },
}

export {
    promotionsService,
}
